import React from 'react';
import { Link } from 'react-router-dom';
import Filters from './Filters';

function AllTableData() {
    return (
        <>
            <div className="container-fluid pt-100px">
                <div className="row pt-2">
                    <div className="col-sm-12 col-md-3 col-lg-3">
                    <Filters />
                    </div>
                    <div className="col-sm-12 col-md-9 col-lg-9 px-0">
                        <Link className="back-text d-flex align-items-center mb-2 mt-2" to="/"><span><img src="./assets/images/arrow_drop_down.svg" alt="" /></span> Back</Link>

                        <div className="filter-box" style={{ borderRight: '0px' }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div><h5>Recent Message Logs</h5></div>
                                <div>
                                    <div className="searchBox">
                                        <input type="text" placeholder="Search" className="form-control" />
                                        <span><img src="./assets/images/search.svg" alt="" /></span>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table tbl_allData">
                                    <thead>
                                        <tr>
                                            <th>Date; time</th>
                                            <th>Country</th>
                                            <th>Province</th>
                                            <th>District</th>
                                            <th>Camp</th>
                                            <th>Preview Message</th>
                                            <th>Message</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>

                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>
                                        <tr>
                                            <td>00:45:09; 23/02/2024</td>
                                            <td>Zambia</td>
                                            <td>Eastern</td>
                                            <td>Chasefu</td>
                                            <td>Chibisa</td>
                                            <td>---Emergency!---</td>
                                            <td>Water temperature  is reaching 12  C!!</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllTableData